module.exports = __webpack_public_path__ + "static/media/hat-cowboy.d8fd6c70.svg";